import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { isNumeric } from '../../utils/Numeric';
import { confirmEnding } from '../../utils/String';

import {
  message, Modal,
  Affix,
  Checkbox, Select, Button,
} from 'antd';
import {
  UploadOutlined,
  ExclamationCircleOutlined,
  CheckCircleTwoTone,
  DiffOutlined,
  SyncOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import { default as SyncDB } from './sync';
import { Page } from '../../components';
import { insertSpecs, getGoodsBySpecName as getGoodsTableBySpecName } from '../../services/Goods';
import { insertGoods, insertGoodsPrice } from '../../services/Buyer';
import { getDatetime } from '../../services/Login';
export default React.forwardRef((props, ref) => {
  const { isPreAdd, importMode, type, buyerId, buyerGoodsCode, onCloseCallback, buyerGoods, getBuyerGoods, onImportOrderGoods, buyerIsBatchDelivery, buyerDeliveryDeadlineDates } = props;

  const [range, setRange] = useState(1);
  const [fileName, setFileName] = useState('');
  const [rows, setRows] = useState([]);
  const [goodsSpecCol, setGoodsSpecCol] = useState(undefined);
  const [goodsPriceCol, setGoodsPriceCol] = useState(undefined);
  const [goodsCountCol, setGoodsCountCol] = useState(undefined);
  const [goodsCommentCol, setGoodsCommentCol] = useState(undefined);
  const [goodsCountAddCol, setGoodsCountAddCol] = useState(undefined);
  const [goodsCountMon1Col, setGoodsCountMon1Col] = useState(undefined);
  const [goodsCountMon2Col, setGoodsCountMon2Col] = useState(undefined);
  const [goodsCountMon3Col, setGoodsCountMon3Col] = useState(undefined);

  const [isShowSyncDb, setShowSyncDb] = useState(false);
  const [datetime, setDatetime] = useState(undefined);

  const [isChecking, setChecking] = useState(false);
  const [isSyncing, setSyncing] = useState(false);
  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    getDatetime().then(data => setDatetime(data));
  }, []);

  useEffect(() => {
    initRowsCount();
  }, [goodsCountCol]);

  const onChangeSpecCol = (col) => {
    setChecked(false);
    initRowsStatus();
    setGoodsSpecCol(col);
  }

  const onChangeCountCol = (col) => {
    setGoodsCountCol(col);
  }
  const onChangeCommentCol = (col) => {
    setGoodsCommentCol(col);
  }

  const onChangePriceCol = (col) => {
    setChecked(false);
    initRowsStatus();
    setGoodsPriceCol(col);
  }

  const onSaveCallback = (goods, callback) => {
    try {
      const key = 'insert goods spec';
      const temp = [].concat(rows);

      const insertArr = [];
      goods.forEach(x => {
        const find = insertArr.find(y => y.goods_id === x.goods_id);
        if (find) {
          find.specs.push(x);
        } else {
          insertArr.push({
            goods_id: x.goods_id,
            specs: [x]
          });
        }
      });

      const arr = [];
      insertArr.forEach(x => {
        arr.push(
          new Promise((resolve, reject) => {
            insertSpecs(x.goods_id, x.specs).then(data => {
              message.loading({ content: `正在同步${x.goods_name}...`, key });
              x.specs.forEach(ss => {
                temp[ss.idx]._status = 2;
              });
              resolve(true)
            })
          })
        );
      });

      Promise.all(arr).then(values => {
        message.success({ content: `产品库添加完成 [ ${values.length}] 条数据  `, key, duration: 2 });
        callback && callback();
      });
    } catch (e) {

    }
  }

  const onClickAdd = (i) => {
    rows[i]._selected = true;
    setShowSyncDb(true);
  }

  const syncBuyerDB = async () => {
    setSyncing(true);
    const key = 'update_goods';
    const temp = [].concat(rows);
    const insert = temp.filter(x => x._status === 2).map(y => ({
      idx: y._idx,
      goods_spec_name: y._goods_spec_name,
      buyer_id: buyerId,
      goods_id: y._goods_id,
      goods_spec_id: y._goods_spec_id,
      pcs_per_carton: y.pcs_per_carton,
      price: y._price,
      start_time: datetime,
      end_time: '2099-12-31 23:59:59'
    }));
    const insert1 = temp.filter(x => x._status === 3 || x._status === 5).map(y => ({
      idx: y._idx,
      goods_spec_name: y._goods_spec_name,
      buyer_id: buyerId,
      goods_id: y._goods_id,
      goods_spec_id: y._goods_spec_id,
      pcs_per_carton: y.pcs_per_carton,
      price: y._price,
      start_time: datetime,
      end_time: '2099-12-31 23:59:59'
    }));


    if (insert.length > 0) {
      insertGoods(buyerId, insert).then(data => {
        const arr = [];
        insert.forEach((x, i) => {
          arr.push(
            new Promise(async (resolve, reject) => {
              return insertGoodsPrice(buyerId, x.goods_id, x.goods_spec_id, x).then(data2 => {
                message.loading({ content: `正在同步${x.goods_spec_name}...`, key });
                temp[x.idx]._status = 0;
                resolve(true);
              });
            })
          );
        });

        insert1.forEach((x, i) => {
          arr.push(
            new Promise(async (resolve, reject) => {
              try {
                await insertGoodsPrice(buyerId, x.goods_id, x.goods_spec_id, x).then(data => {
                  message.loading({ content: `正在同步${x.goods_spec_name}...`, key });
                  temp[x.idx]._status = 0;
                  resolve(true);
                });
              } catch (e) {
                resolve(false);
              }
            })
          );
        });
        Promise.all(arr).then(values => {
          message.success({ content: `同步完成 [ ${values.length}] 条数据 `, key, duration: 1 });
          getBuyerGoods(() => setRows(temp));
          setSyncing(false);
        });
      });
    } else if (insert.length === 0) {
      const arr = [];
      insert1.forEach((x, i) => {
        arr.push(
          new Promise(async (resolve, reject) => {
            try {
              await insertGoodsPrice(buyerId, x.goods_id, x.goods_spec_id, x).then(data => {
                message.loading({ content: `正在同步${x.goods_spec_name}...`, key });
                temp[x.idx]._status = 0;
                resolve(true);
              });
            } catch (e) {
              resolve(false);
            }
          })
        );
      });
      Promise.all(arr).then(values => {
        message.success({ content: `同步完成 [ ${values.length}] 条数据 `, key, duration: 1 });
        getBuyerGoods(() => setRows(temp));
        setSyncing(false);
      });
    } else {

    }
  }

  const initRowsStatus = () => {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      row._status = undefined;
    }
  }

  const initRowsCount = () => {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const count = isNumeric(row[goodsCountCol]) ? parseFloat(row[goodsCountCol]) : 0;
      row._count = count;
    }
  }

  const initRows = () => {
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const name = ((row[goodsSpecCol] || '')+"").trim();
      const count = isNumeric(row[goodsCountCol]) ? parseFloat(row[goodsCountCol]) : 0;
      const price = isNumeric(row[goodsPriceCol]) ? parseFloat(row[goodsPriceCol]) : undefined;
      row._idx = i;
      if (name.length === 0) {
        row._status = -1;
      } else {
        row._status = undefined;
      }
      if (buyerGoodsCode && confirmEnding(name, buyerGoodsCode)) {
        row._goods_spec_name = name.substr(0, name.length - buyerGoodsCode.length);
      } else {
        row._goods_spec_name = name;
      }
      //row._goods_spec_name = name;
      row._price = price;
      row._count = count;
    }
  }

  const checkExistsData = () => {
    rows.filter(x => x._status === undefined).forEach(x => {
      const find = buyerGoods.find(y => y.goods_spec_name === x._goods_spec_name);
      if (find) {
        x._status = 0;
        x._goods_id = find.goods_id;
        x._goods_spec_id = find.goods_spec_id;
        if (!find.price) {
          x._status = -1;
        } else {
          if (x._price !== find.price) {
            x._status = 3;
          }
        }
      } else {
        x._status = 2;
      }
    })
  }

  const checkGoodsTable = (callback) => {
    const arr = [];
    const temp = rows.filter(x => x._status === 2);
    const key = 'update_goods';
    temp.forEach(x => {
      const name = x._goods_spec_name;
      if (name.length > 0) {
        arr.push(
          new Promise(async (resolve, reject) => {
            message.loading({ content: `正在校验${name}...`, key });
            try {
              await getGoodsTableBySpecName(name).then(goodsData => {
                message.loading({ content: `正在校验${name}...`, key });
                x._goods_id = goodsData.goods_id;
                x._goods_spec_id = goodsData.id;
                resolve(true);
              });
            } catch (e) {
              x._status = 1;
              resolve(false);
            }
          })
        );
      }
    })

    Promise.all(arr).then(values => {
      callback && callback();
      message.success({ content: `数据校验完成 [ ${values.length}] 条数据  `, key, duration: 1 });
    })
  }
  const checkBuyerDB = async () => {
    setChecking(true);
    initRows();
    checkExistsData();
    checkGoodsTable(() => {
      const temp = [].concat(rows);
      setRows(temp);
      setChecking(false);
      setChecked(temp.filter(x => x._status > 0 && x._status < 3).length === 0 && temp.filter(x => x._status === undefined).length === 0);
    });
  }

  const onSelected = (checked, i) => {
    const temp = [].concat(rows);
    temp[i]._selected = checked;
    setRows(temp);
  }

  const onImportOrder = () => {
    const datas = [];
    rows.filter(x => (x._status === 0 || x._status === 3) && x._count).forEach((row, i) => {
      const find = buyerGoods.find(y => y.goods_spec_name === row._goods_spec_name);
      if (find) {
        let count = 0;
        let count_add = 0;
        let count_mon1 = 0;
        let count_mon2 = 0;
        let count_mon3 = 0;
        if (goodsCountAddCol) {
          if (!isNaN(row[goodsCountAddCol])) {
            count_add = parseInt(row[goodsCountAddCol])
          }
        }
        if (goodsCountMon1Col) {
          if (!isNaN(row[goodsCountMon1Col])) {
            count_mon1 = parseInt(row[goodsCountMon1Col])
          }
        }
        if (goodsCountMon2Col) {
          if (!isNaN(row[goodsCountMon2Col])) {
            count_mon2 = parseInt(row[goodsCountMon2Col])
          }
        }
        if (goodsCountMon3Col) {
          if (!isNaN(row[goodsCountMon3Col])) {
            count_mon3 = parseInt(row[goodsCountMon3Col])
          }
        }
        if (goodsCountCol) {
          if (!isNaN(row[goodsCountCol])) {
            count = parseInt(row[goodsCountCol])
          }
        }
        datas.push(Object.assign({}, find, {
          _status: row._status,
          price_start_time: find.start_time,
          count_add,
          count_mon1,
          count_mon2,
          count_mon3,
          count,
          remark: goodsCommentCol ? (row[goodsCommentCol] ? row[goodsCommentCol] : '') : ''
        }));
      }
    });
    if (datas.length === 0) {
      Modal.error({
        title: '产品无效',
        content: '该订单中无有效产品，请确认产品号、单价！',
      });
      return;
    }

    if (datas.filter(x => x._status === 3).length > 0) {
      Modal.confirm({
        title: `确定导入当前${datas.length}条产品吗?`,
        icon: <ExclamationCircleOutlined />,
        content: <strong>
          当前订单中存在价格不一致产品，是否使用数据库中单价进行导入？<br />
          {datas.map(x => (<span>{x.goods_spec_name}<span style={{ color: 'red' }}>{x._status === 3 ? '(价格不一致)' : ''}</span>, </span>))}</strong>,
        okText: 'Yes',
        centered: true,
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          onImportOrderGoods(datas, onCloseCallback)
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.confirm({
        title: `确定导入当前${datas.length}条产品吗?`,
        icon: <ExclamationCircleOutlined />,
        content: <strong>{datas.map(x => (<span>{x.goods_spec_name}, </span>))}</strong>,
        okText: 'Yes',
        centered: true,
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          onImportOrderGoods(datas, onCloseCallback)
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }
  }

  const onExportExcel = () => {
    // 获取表格的dom元素
    var elt = document.getElementById('import-table');
    console.log(elt)
    // 将表格的dom 元素转化为 excel工作薄
    var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
    // 将工作薄导出为excel文件
    XLSX.writeFile(wb, '比对结果_' + fileName + '.xlsx');
  }

  const onImportExcel = file => {
    // 获取上传的文件对象
    const { files } = file.target;
    if (files.length === 0) return;
    setFileName(files[0].name);

    // 通过FileReader对象读取文件
    const fileReader = new FileReader();
    fileReader.onload = event => {
      try {
        const { result } = event.target;

        // 以二进制流方式读取得到整份excel表格对象
        const workbook = XLSX.read(result, { type: 'binary' });
        // 存储获取到的数据
        let data = [];
        // 遍历每张工作表进行读取（这里默认只读取第一张表）
        for (const sheet in workbook.Sheets) {
          // esline-disable-next-line
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            // 利用 sheet_to_json 方法将 excel 转成 json 数据
            console.log(sheet)
            data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {range: range-1}));
            setRows(data);
            break; // 如果只取第一张表，就取消注释这行
          }
        }
        setChecked(false);
        setGoodsSpecCol(undefined);
        setGoodsPriceCol(undefined);
        setGoodsCountCol(undefined);
        // 最终获取到并且格式化后的 json 数据
        message.success('导出文件完成！')
        console.log(data);
      } catch (e) {
        // 这里可以抛出文件类型错误不正确的相关提示
        message.error('文件类型不正确！');
      }
    };
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(files[0]);
  }

  const columns = [];
  if (rows.length > 0) {
    for (const key in rows[0]) {
      if (!key.startsWith('_'))
        columns.push(key);
    }
  }

  const parseHeader = () => {
    const tds = [];
    tds.push(<th className="th"><Checkbox>#</Checkbox></th>)
    columns.forEach(x => {
      tds.push(<th>{x}</th>);
    })
    return <tr>{tds}</tr>
  }

  const parseRow = (row, i) => {
    const tds = [];
    tds.push(<td className="td"><Checkbox disabled={row._status != 1} onChange={(e) => onSelected(e.target.checked, i)} checked={row._selected && row._status === 1}>{i + 1}</Checkbox></td>);
    columns.forEach(x => {
      if (x === goodsSpecCol) {
        if (row._status === 0) {
          tds.push(<td className="td">{row[x]} <CheckCircleTwoTone twoToneColor="#52c41a" /></td>);
        } else if (row._status === -1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
        } else if (row._status === 1) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#F50' }}>产品库不存在 <Button hidden={true} onClick={() => onClickAdd(i)} size="small" type="link" icon={<PlusCircleOutlined />}></Button></span></td>);
        } else if (row._status === 2) {
          tds.push(<td className="td">{row[x]} <span style={{ color: '#FF8C00' }}>客户库不存在</span></td>);
        } else {
          tds.push(<td className="td">{row[x]}</td>);
        }
      } else if (x === goodsPriceCol) {
        if (row._status === 3 || row._status === 5) {
          const find = buyerGoods.find(x => x.goods_spec_name === row._goods_spec_name) || {};
          tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>不一致({find.price})</span></td>);
        } else {
          if (row[x] <= 0.00001) {
            tds.push(<td className="td">{row[x]} <span style={{ color: 'red' }}>无效数据</span></td>);
          } else {
            tds.push(<td className="td">{row[x]}</td>);
          }
        }
      } else {
        tds.push(<td className="td">{row[x]}</td>);
      }
    });
    return <tr>{tds}</tr>
  }

  const buttons_jidu = () => {
    if (importMode === 1) return undefined;
    const arr = [];
    if (isPreAdd) {
      arr.push(
        <span>
          {fileName && <span>&nbsp;上季追加:</span>}
          {
            fileName && <Select value={goodsCountAddCol} onChange={setGoodsCountAddCol} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
    }
    if (type === 21) {
      arr.push(
        <span>
          {fileName && <span>&nbsp;1月:</span>}
          {
            fileName && <Select value={goodsCountMon1Col} onChange={setGoodsCountMon1Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;2月:</span>}
          {
            fileName && <Select value={goodsCountMon2Col} onChange={setGoodsCountMon2Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;3月:</span>}
          {
            fileName && <Select value={goodsCountMon3Col} onChange={setGoodsCountMon3Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
    } else if (type === 22) {
      arr.push(
        <span>
          {fileName && <span>&nbsp;4月:</span>}
          {
            fileName && <Select value={goodsCountMon1Col} onChange={setGoodsCountMon1Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;5月:</span>}
          {
            fileName && <Select value={goodsCountMon2Col} onChange={setGoodsCountMon2Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;6月:</span>}
          {
            fileName && <Select value={goodsCountMon3Col} onChange={setGoodsCountMon3Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>)
    } else if (type === 23) {
      arr.push(
        <span>
          {fileName && <span>&nbsp;7月:</span>}
          {
            fileName && <Select value={goodsCountMon1Col} onChange={setGoodsCountMon1Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;8月:</span>}
          {
            fileName && <Select value={goodsCountMon2Col} onChange={setGoodsCountMon2Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;9月:</span>}
          {
            fileName && <Select value={goodsCountMon3Col} onChange={setGoodsCountMon3Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>)
    } else if (type === 24) {
      arr.push(
        <span>
          {fileName && <span>&nbsp;10月:</span>}
          {
            fileName && <Select value={goodsCountMon1Col} onChange={setGoodsCountMon1Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;11月:</span>}
          {
            fileName && <Select value={goodsCountMon2Col} onChange={setGoodsCountMon2Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>);
      arr.push(
        <span>
          {fileName && <span>&nbsp;12月:</span>}
          {
            fileName && <Select value={goodsCountMon3Col} onChange={setGoodsCountMon3Col} style={{ width: '90px' }}>
              {
                columns.map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          }
        </span>)
    }
    return arr;
  }
  return (
    <div className='goods-import-container'>
      <div className="goods-import-button-group">
        <div className='goods-import-file-name'> {fileName} </div>
        <div icon={<UploadOutlined />} className='upload-wrap'>
          <input className='file-uploader' type='file' accept='.xlsx, .xls' onChange={onImportExcel} />
          <span className='upload-text'>选择文件...</span>
        </div>
        <div className='upload-tip'>支持 .xlsx、.xls文件</div>
        &nbsp;&nbsp;
        <div><strong>产品开始行&nbsp;<Select onChange={setRange} value={range} style={{width:'60px'}}>
          {
          [1,2,3,4,5].map(x=> {
            return <Select.Option key={x} value={x}>{x}</Select.Option>
          })
        }
          </Select></strong></div>
        {rows.filter(x => x._status > 0).length > 0 && <div style={{ fontSize: '1.5rem', marginLeft: 'auto' }}>比对结果: 共有[<span style={{ color: 'red' }}><strong>{rows.filter(x => x._status > 0).length}</strong></span>]条数据不一致，请查证后重新比对导入</div>}
        {(rows.filter(x => x._status > 0).length === 0 && isChecked) && <div style={{ fontSize: '1.5rem', marginLeft: 'auto' }}>比对结果: [<span style={{ color: 'green' }}><strong>成功</strong></span>],可以导入到订单</div>}
        {/* {
          fileName && <div style={{ paddingLeft: '1rem', marginLeft: 'auto' }}>
            <Checkbox onChange={(e) => setCreateSubOrder(e.target.checked)} checked={isCreateSubOrder}>创建多个订单</Checkbox>
            <Select value={isCreateSubOrder ? subOrderCount : undefined} disabled={!isCreateSubOrder} style={{ width: '60px' }}>
              {
                [2, 3, 4, 5, 6].map(x => {
                  return <Select.Option key={x} value={x}>{x}</Select.Option>
                })
              }
            </Select>
          </div>
        } */}
      </div>
      <div className="goods-import-filter-group">
        {fileName && <span>&nbsp;&nbsp;<span style={{ color: 'red' }}>*</span>产品号:&nbsp;</span>}
        {
          fileName && <Select value={goodsSpecCol} onChange={onChangeSpecCol} style={{ width: '120px' }}>
            {
              columns.map(x => {
                return <Select.Option key={x} value={x}>{x}</Select.Option>
              })
            }
          </Select>
        }
        {fileName && <span>&nbsp;&nbsp;<span style={{ color: 'red' }}>*</span>单价:&nbsp;</span>}
        {
          fileName && <Select value={goodsPriceCol} onChange={onChangePriceCol} style={{ width: '120px' }}>
            {
              columns.map(x => {
                return <Select.Option key={x} value={x}>{x}</Select.Option>
              })
            }
          </Select>
        }
        {buttons_jidu()}
        {fileName && <span>&nbsp;&nbsp;<span style={{ color: 'red' }}>*</span>数量:&nbsp;</span>}
        {
          fileName && <Select value={goodsCountCol} onChange={onChangeCountCol} style={{ width: '120px' }}>
            {
              columns.map(x => {
                return <Select.Option key={x} value={x}>{x}</Select.Option>
              })
            }
          </Select>
        }
        {fileName && <span>&nbsp;&nbsp;备注:&nbsp;</span>}
        {
          fileName && <Select value={goodsCommentCol} onChange={onChangeCommentCol} style={{ width: '120px' }}>
            {
              columns.map(x => {
                return <Select.Option key={x} value={x}>{x}</Select.Option>
              })
            }
          </Select>
        }
        <div style={{ marginLeft: 'auto' }}></div>
        {
          (rows.length > 0 && goodsSpecCol !== undefined && goodsPriceCol !== undefined) && <Affix offsetTop={92}>
            <Button icon={<DiffOutlined />} disabled={isSyncing} loading={isChecking} type="primary" onClick={() => checkBuyerDB()}>
              数据比对
            </Button>
            <Button hidden={true} loading={isSyncing} disabled={isChecking || rows.filter(x => x._status > 1).length === 0} icon={<SyncOutlined />} type="primary" onClick={() => syncBuyerDB()}>
              数据库同步
            </Button>
            {fileName && <Button onClick={onExportExcel}>导出到Excel...</Button>}
            {fileName && <Button onClick={onImportOrder} disabled={!isChecked} type="primary">导入到当前订单</Button>}
          </Affix>
        }
      </div>
      <div className="goods-import-content">
        <table id="import-table" border="1" className="goods_table">
          {
            rows.length > 0 && parseHeader(rows[0])
          }
          {
            rows.map((x, i) => parseRow(x, i))
          }
        </table>
      </div>
      <Page
        visible={isShowSyncDb}
        onCloseCallback={() => setShowSyncDb(false)}
        title="产品库同步"
        width="1024px"
        body={<SyncDB
          rows={rows}
          goodsSpecCol={goodsSpecCol}
          onSaveCallback={onSaveCallback}
          onCloseCallback={() => setShowSyncDb(false)} />}
      />
    </div >
  );
});